import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-domain-management-form',
  templateUrl: './domain-management-form.component.html',
  styleUrls: ['./domain-management-form.component.scss']
})
export class DomainManagementFormComponent {

  public data: any = {own_ssl_certificate: 0, status: 1};
  public ip_addresses: any = [];
  public selected_company: string = '';
  public setup_domain_message: string = '';
  public setup_domain: boolean = false;
  public players: any = [];
  constructor(private http: HttpService, private router: Router, private activateRoute: ActivatedRoute) {
    this.selected_company = this.http.getStaticSelectedCompany();
    this.activateRoute.params.subscribe(async (params) => {
      if(params['domain_uuid']) {
        await this.getDomain(params['domain_uuid']);
      }
    });
    this.init();
  }

  async init() {
    const rtn:any = await this.http.post("/admin/server-ip/get");
    this.ip_addresses = rtn;
    this.data.ip_address = this.ip_addresses[0].ip;
    await this.getPlayers();
  }

  async getDomain(uuid: string) {
    let rtn:any = await this.http.post("/admin/domain/get-detail", {uuid: uuid})
    console.log(rtn);
    this.data = rtn
  }

  cancel() {
    this.router.navigate(['/lo', this.selected_company, 'domain-management']);
  }

  async submit() {
    let rtn:any = await this.http.post("/admin/domain/save", this.data)
    if(rtn.status) {
      this.router.navigate(['/lo', this.selected_company, 'domain-management', 'form', rtn.uuid]);
    }
  }

  readSSLFile(file: any) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.data.cert = e.target.result;
    }
    reader.readAsText(file.target.files[0]);
  }

  readSSLPrivateKeyFile(file: any) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.data.cert_private = e.target.result;
    }
    reader.readAsText(file.target.files[0]);
  }

  setupDomain() {
    this.setup_domain = true;
    this.http.post("/admin/domain/setup", {domain_uuid: this.data.uuid})
    this.setup_domain_message = "bla bla some text about setting up domain"
  }

  async getPlayers() {
    let players = await this.http.post("/admin/agent/get")
    console.log(players);
    this.players = players
  }
}
